import type { PT } from "~/hooks/usePrismicLabel";

export type GetDeliveryEstimateParams = {
  $pt: PT;
  deliveryEstimate?: string;
  deliveryDate?: string;
  workingDays?: string;
  defaultShipping?: string;
  includeNotApplicableText?: boolean;
};

export function getDeliveryEstimate({
  $pt,
  deliveryEstimate,
  deliveryDate,
  workingDays,
  defaultShipping,
  includeNotApplicableText = false,
}: GetDeliveryEstimateParams) {

  const dayOfWeek = new Date().getDay();
  const isSaturday = dayOfWeek === 6;
  const isSunday = dayOfWeek === 0;

  const isPostNl = defaultShipping?.toLowerCase().includes("postnl");

  if (isSaturday)
    return isPostNl
      ? $pt("delivery_estimate_sat_postnl")
      : $pt("delivery_estimate_sat_trans");

  if (isSunday)
    return isPostNl
      ? $pt("delivery_estimate_sun_postnl")
      : $pt("delivery_estimate_sun_trans");

  switch (deliveryEstimate) {
    case "DEFAULT":
      return $pt("delivery_estimate_default");
    case "NOT_APPLICABLE":
      return includeNotApplicableText
        ? $pt("delivery_estimate_not_applicable")
        : "";
    case "DELIVERED_AT_SAME_DAY":
      return $pt("delivery_estimate_same_day");
    case "DELIVERED_AT_FOUR":
      return $pt("delivery_estimate_by_four");
    case "DELIVERED_ON_SPECIFIC_DATE": {
      const specificDate = $pt("delivery_estimate_specific_date");
      return deliveryDate
        ? specificDate?.replace("DD-MM-YYYY", deliveryDate)
        : specificDate;
    }
    case "DELIVERED_IN_X_WORKING_DAYS": {
      const workingDaysText = $pt("delivery_estimate_x_working_days");
      return workingDays
        ? workingDaysText?.replace("X-Y", workingDays)
        : workingDaysText;
    }
    default:
      return $pt("delivery_estimate_default");
  }
}

